// GallerySection.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./GallerySection.css";

const GallerySection = ({ images }) => (
  <>
    <div className="gallery-section-divider fade-in-up">
      <hr className="gallery-divider-line" />
      <h4 className="gallery-divider-text">Explore Our New Items</h4>
      <hr className="gallery-divider-line" />
    </div>
    <h3 className="gallery-signature-text">Signature Gift Boxes</h3>
    <div className="gallery-container fade-in-up">
      <Swiper
        slidesPerView={4}
        spaceBetween={10}
        breakpoints={{
          320: { slidesPerView: 2 },
          480: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        loop={true}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        modules={[Autoplay]}
      >
        {images.map((img, idx) => (
          <SwiperSlide key={idx} className="gallery-slide">
            <div className="gallery-card">
              <img src={img.image} alt={`Gallery ${idx}`} className="gallery-image" />
              <div className="gallery-card-glow"></div>
              <div className="gallery-card-shimmer"></div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </>
);

export default GallerySection;